export default "__VITE_ASSET__BwepyNaD__"